// extracted by mini-css-extract-plugin
module.exports = {"root":"DeliveryFeeStrip_root___F53l","icon":"DeliveryFeeStrip_icon__QyKV_"};